export const anytimeTicketKeys = {
	all: ['anytime-tickets'] as const,
	productsList: (isStaff: boolean, customerId?: string | null) =>
		[...anytimeTicketKeys.all, 'products-list', { isStaff, customerId: customerId ?? null }] as const,
	staffEntitlements: (filters: any) => [...anytimeTicketKeys.all, 'staff-entitlements', filters] as const,
};
